import { render } from "./SourceMaterial.vue?vue&type=template&id=70e5b0f9&scoped=true&ts=true"
import script from "./SourceMaterial.vue?vue&type=script&lang=ts"
export * from "./SourceMaterial.vue?vue&type=script&lang=ts"

import "./SourceMaterial.vue?vue&type=style&index=0&id=70e5b0f9&lang=less&scoped=true"

import exportComponent from "/home/jenkins_home/workspace/c1-02_dwart2.0-apkpc-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70e5b0f9"]])

export default __exports__